import { render, staticRenderFns } from "./EditRequestModal.vue?vue&type=template&id=57088e7e&"
import script from "./EditRequestModal.vue?vue&type=script&lang=js&"
export * from "./EditRequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports